import * as _actions from './actions';
import * as _accessors from './accessors';
import _reducer from './reducer';
import _ScoreBand from './model';

_ScoreBand.actions = _actions;
_ScoreBand.accessors = _accessors;

export const actions = _actions;
export const accessors = _accessors;
export const reducer = _reducer;
export const ScoreBand = _ScoreBand;



// WEBPACK FOOTER //
// ./data/ScoreBand/index.js